export function getRingOffsets(ringPos: number, length: number, max: number) {
  const a = (max - ringPos) * 128
  const b = length
  const c = 0
  const d = (ringPos + 1) * 128

  const e = 0
  const f = a
  const g = d
  const h = length

  return [a, b, c, d, e, f, g, h]
}

export function copyRingInto(target: Float32Array, source: Float32Array, ringPos: number, length: number, max: number) {
  const [a, b, c, d, e, f, g, h] = getRingOffsets(ringPos, length, max)

  target
    .subarray(a, b)
    .set(
      source.subarray(c, d)
    )

  target
    .subarray(e, f)
    .set(
      source.subarray(g, h)
    )
}

export function test() {
  describe('getRingOffsets', () => {
    const passing: [number, number[]][] = [
      [0, [1920, 2048, 0, 128, 0, 1920, 128, 2048]],
      [1, [1792, 2048, 0, 256, 0, 1792, 256, 2048]],
      [14, [128, 2048, 0, 1920, 0, 128, 1920, 2048]],
      [15, [0, 2048, 0, 2048, 0, 0, 2048, 2048]],
    ]

    passing.forEach(([ringPos, expected]) => {
      it(`${ringPos}`, () => {
        const r = getRingOffsets(ringPos, 2048, 15)
        expect(r).toEqual(expected)
      })
    })
  })
}
